import React from "react";
import styles from "./Controls.module.scss";

interface ControlsProps {
  count: string;
  onPrev: () => void;
  onNext: () => void;

  canPrev?: boolean;
  canNext?: boolean;

  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;

  isAnimating?: boolean;
}

export const Controls: React.FC<ControlsProps> = ({
  count,
  onPrev,
  onNext,
  canPrev,
  canNext,
  isPrevDisabled,
  isNextDisabled,
  isAnimating = false,
}) => {
  const prevDisabled =
    isAnimating || isPrevDisabled === true || (canPrev !== undefined && !canPrev);

  const nextDisabled =
    isAnimating || isNextDisabled === true || (canNext !== undefined && !canNext);

  return (
    <div className={styles.controls}>
      <div className={styles.count}>{count}</div>

      <div className={styles.buttons}>
        <button
          type="button"
          aria-label="Previous period"
          className={`${styles.btn} ${prevDisabled ? styles.disabled : ""}`}
          onClick={onPrev}
          disabled={prevDisabled}
        />
        <button
          type="button"
          aria-label="Next period"
          className={`${styles.btn} ${nextDisabled ? styles.disabled : ""}`}
          onClick={onNext}
          disabled={nextDisabled}
        />
      </div>
    </div>
  );
};

